import request from '@/utils/request'

// 打卡活动列表
export function getPunchclockList(params) {
  // return request({
  //   url: `/v2/api/app/ad_activity/activity/query/my/sign_up/page?page=${params.page}&size=${params.size}&memberId=${params.memberId}`,
  //   method: 'get',
  // })
  return request({
    url: `/v2/api/app/ad_activity//activity/query_my_activity?page=${params.page}&size=${params.size}&memberId=${params.memberId}`,
    method: 'get'
  })
}
// 打卡详情
export function catDetailById(params) {
  console.log(params);
  return request({
    url: `/v2/api/app/ad_activity/activity/query_web_info?id=${params.id}&memberId=${params.memberId}`,
    method: 'get',
  })
}
// 查询当前活动志愿者打卡情况
export function catMemberById(activityId) {
  return request({
    url: `/v2/api/app/ad_activity/activity/query/activity/member/sign_in_count?activityId=${activityId}`,
    method: 'get',
  })
}
// 活动签到签退
export function signActivity(data) {
  return request({
    url: `/v2/api/app/ap_member/member/add/sign_in`,
    method: 'post',
    data
  })
}

export default { getPunchclockList, catDetailById, catMemberById, signActivity }